export default {"src":"/_next/static/media/plus.fce0c7aa.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};